import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/es"; // Importar español

const Equipos = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    nombreUsuario: "",
    tipo: "",
    impresora: "",
    sistemaOperativo: "",
    funcion: "",
    operadores: "",
    fechaAdquisicion: null,
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateChange = (date) => {
    setFormData((prev) => ({
      ...prev,
      fechaAdquisicion: date ? dayjs(date).format("YYYY-MM") : "",
    }));
  };

  const handleSubmit = () => {
    onSubmit(formData);
  };

  return (
    <Box>
      <p style={{ fontSize: "13px", color: "gray", marginBottom: "10px" }}>
        Para obtener el nombre completo del equipo en{" "}
        <strong>Windows XP</strong>, haz clic en el bot&oacute;n de{" "}
        <strong>Inicio</strong>, luego haz clic derecho sobre{" "}
        <strong>Mi PC</strong> o <strong>Equipo</strong>, selecciona{" "}
        <strong>Propiedades</strong>, ve a la pesta&ntilde;a{" "}
        <strong>Nombre de equipo</strong> y anota el valor junto a{" "}
        <strong>Nombre completo de equipo</strong>. En{" "}
        <strong>Windows 7 y Windows Vista</strong>, haz clic en{" "}
        <strong>Inicio</strong>, luego clic derecho sobre{" "}
        <strong>Equipo</strong>, selecciona <strong>Propiedades</strong>,
        despl&aacute;zate hasta la secci&oacute;n{" "}
        <strong>Ver informaci&oacute;n b&aacute;sica acerca del equipo</strong>,
        y en{" "}
        <strong>
          Configuraci&oacute;n de nombre, dominio y grupo de trabajo
        </strong>
        , anota el nombre completo del equipo. En{" "}
        <strong>Windows 8 y Windows 10</strong>, haz clic derecho sobre el{" "}
        <strong>bot&oacute;n de Inicio</strong>, selecciona{" "}
        <strong>Sistema</strong>, dir&iacute;gete a{" "}
        <strong>Especificaciones del dispositivo</strong> y anota el valor junto
        a <strong>Nombre del dispositivo</strong>.
      </p>
      <TextField
        fullWidth
        label="Nombre de usuario (Identificación del equipo)"
        name="nombreUsuario"
        value={formData.nombreUsuario}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Tipo (Sobremesa, portátil, etc.)"
        name="tipo"
        value={formData.tipo}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Impresora (Modelo o impresoras conectadas)"
        name="impresora"
        value={formData.impresora}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Sistema Operativo"
        name="sistemaOperativo"
        value={formData.sistemaOperativo}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Función (Puesto, servidor, unidad de copia, etc.)"
        name="funcion"
        value={formData.funcion}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Operadores (Personal que trabaja en ese equipo)"
        name="operadores"
        value={formData.operadores}
        onChange={handleChange}
        margin="normal"
      />
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
        <DatePicker
          views={["year", "month"]}
          label="Fecha de adquisición del ordenador"
          value={
            formData.fechaAdquisicion ? dayjs(formData.fechaAdquisicion) : null
          }
          onChange={handleDateChange}
          sx={{ width: "100%" }}
          renderInput={(params) => (
            <TextField fullWidth margin="normal" {...params} />
          )}
        />
      </LocalizationProvider>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 2 }}
        onClick={handleSubmit}
      >
        Guardar Información
      </Button>
    </Box>
  );
};

export default Equipos;
